<template>
	<v-sheet class="sliderContent" :style="style">
		<slot></slot>
	</v-sheet>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch, Provide } from "vue-property-decorator";
import SliderService from "../services/sliderService";

@Component
export default class SliderContent extends Vue {
	@Prop({ default: false }) value: boolean;
	@Emit() input() { return this.visible; }
	@Prop() slots: any;

	visible: boolean = false;
	size: string | number | null = null;
	width = null;

	get style() {
		return {
			width: this.width
		}
	}

	@Watch("slots", { immediate: true })
	onSlotsChanged() {
		this.$slots.default = this.slots;
	}

	@Watch("value", { immediate: true })
	onValueChanged() {
		this.visible = !!this.value;
	}

	@Watch("size", { immediate: true })
	onSizeChanged() {
		this.width = SliderService.getWidth(this.size);
	}

	@Provide()
	closeSlider() {
		this.visible = false;
		this.input();
	}

	@Provide()
	setSliderContentSize(size: string | number) {
		this.size = size;
	}
}
</script>

<style lang="scss">
	.sliderContent {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		max-width: 100vw;
		// max-height: 100%;
		will-change: width;
	}
</style>